import { RootState } from "app/store"
import {
  TypedUseSelectorHook,
  // eslint-disable-next-line no-restricted-imports
  useSelector as useReduxSelector,
} from "react-redux"

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector
